<template>
    <div id="bodyMajor">
        <el-tabs v-model="activeName" style="height: 600px;" tab-position="left"
         @tab-click="handleClick">
            <el-tab-pane label="不予录取的专业" name="1">
                <el-table :data="(bodyMajorData||majorData1)" border :span-method="objectSpanMethod1"
                :header-cell-style="{'background-color':'#409EFF','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'left',
                'font-size':'16px'}" 
                size="small" max-height="600"
                style="border-bottom: 2px solid #1f4778;border-right: 2px solid #1f4778;
                border-top: 1px solid  #1f4778;border-left: 1px solid #1f4778;">
                    <el-table-column label="疾病情况" prop="diseaseCondition"></el-table-column>
                    <el-table-column label="不予录取的专业" prop="zymcs"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="不宜就读的专业" name="2">
                <el-table :data="majorData2" border :span-method="objectSpanMethod2"
                :header-cell-style="{'background-color':'#409EFF','border': '1px solid #1f4778',
                'color': '#FFF','text-align':'center','font-size':'14px'}"
                :cell-style="{'border': '1px solid #1f4778','text-align':'left',
                    'font-size':'16px'
                }"
                size="small" max-height="600"
                style="border-bottom: 2px solid #1f4778;border-right: 2px solid #1f4778;
                border-top: 1px solid  #1f4778;border-left: 1px solid #1f4778;">
                    <el-table-column label="疾病情况" prop="diseaseCondition"></el-table-column>
                    <el-table-column label="不予就读的专业" prop="zymcs"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
data(){
    return {
        activeName:'1',
        majorData1:[],
        majorData2:[],
        data1CombineList:[],
        data2CombineList:[],
        combieConditionList1:[],
        combieZymcsList1:[],
        noCombieContent1:[],
        combieConditionList2:[],
        combieZymcsList2:[],
        noCombieContent2:[],
        filterRules:[]
    };
},
props:{
    bodyMajorData:{
        type:Array,
        default:[]
    },
    type:{
        type:Number,
        default:0
    },
    conditionList:{
        type:Array,
        default:[]
    },
    zymcsList:{
        type:Array,
        default:[]
    }
},
methods:{
    async handleClick(){
        const activeName=this.activeName;
        if(activeName=='1'){
            await this.getBodyReuiredMajor(activeName);
        }else if(activeName=='2'){
            await this.getBodyReuiredMajor(activeName);
        }
    },
    // 获取有身体要求的专业
    async getBodyReuiredMajor(type){
        const loading=this.$loading({fullscreen:true,
            target:document.getElementById('bodyMajor'),text:'正在加载中'});
        const res=await this.$http.getHttp('/disCon/getInfo?type='+type);
        console.log(res);
        if(res.data.code==200){
            const data=[...res.data.obj];
            // const data=[];
            // if(type=='1'){
            //     data.push(data0[0]);
            // }else{
            //     data.push(data0[0]);
            //     data.push(data0[1]);
            //     data.push(data0[2]);
            // }
            if(type=='1'){
                this.majorData1=data;
            }else if(type=='2'){
                this.majorData2=data;
            }
            for(let i=0;i<data.length;i++){
                if(data[i]){
                    data[i].line=i+1;
                }
            }
            const arr1=[];
            const arr2=[];
            // data.push({diseaseCondition:'a',id:12,seq:1,type,zymcs:'b',line:data.length});
            for(let i=0;i<data.length;i++){
                if(data[i]){
                    const obj={};
                    obj.diseaseCondition=data[i].diseaseCondition;
                    obj.count=0;
                    obj.line=i+1;
                    obj.columnIndex=0;
                    const obj2={};
                    obj2.zymcs=data[i].zymcs;
                    obj2.count=0;
                    obj2.line=i+1;
                    obj2.columnIndex=1;
                    const haveFlag1=arr1.find(item=>{
                        return item.diseaseCondition==obj.diseaseCondition;
                    });
                    if(!haveFlag1){
                        arr1.push(obj);
                    }
                    const haveFlag2=arr2.find(item=>{
                        return item.zymcs==obj2.zymcs;
                    });
                    if(!haveFlag2){
                        arr2.push(obj2);
                    }
                }
            }
            for(let i=0;i<data.length;i++){
                for(let j=0;j<arr1.length;j++){
                    if(data[i].diseaseCondition==arr1[j].diseaseCondition){
                        arr1[j].count++;
                    }
                }
                for(let k=0;k<arr2.length;k++){
                    if(data[i].zymcs==arr2[k].zymcs){
                        arr2[k].count++;
                    }
                }
            }
            if(type=='1'){
                this.combieConditionList1=arr1;
                this.combieZymcsList1=arr2;
            }else if(type=='2'){
                this.combieConditionList2=arr1;
                this.combieZymcsList2=arr2;
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }
        }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
        }
        loading.close();
    },
    // 跨行，跨列
    objectSpanMethod1({row, column, rowIndex, columnIndex}){
        // 疾病情况列跨行情况
        const arr1=this.getSpanArr((this.bodyMajorData||this.majorData1),'diseaseCondition');
        // 不予录取/不予就读的专业情况
        const arr2=this.getSpanArr((this.bodyMajorData||this.majorData1),'zymcs');
        if(columnIndex==0){
            const diseaseConditionCount=arr1[rowIndex];
            return (diseaseConditionCount?{rowspan:diseaseConditionCount,colspan:1}:
            {rowspan:0,colspan:0})
        }
        if(columnIndex==1){
            const zymcs=arr2[rowIndex];
            return (zymcs?{rowspan:zymcs,colspan:1}:
            {rowspan:0,colspan:0})
        }
        return {rowspan:1,colspan:1}
    },
    oldCode2(){
                const arr1=[...this.conditionList];
        const arr2=[...this.zymcsList];
        const arr3=[];
        const arr4=[];
        let haveCombieFlag1=false;
        let haveCombieFlag2=false;
        for(let i=0;i<arr1.length;i++){
            if(arr1[i]&&arr1[i].count>1){
                haveCombieFlag1=true;
                break;
            }
        }
        for(let i=0;i<arr2.length;i++){
            if(arr2[i]&&arr2[i].count>1){
                haveCombieFlag2=true;
                break;
            }
        }
        for(let i=0;i<arr1.length;i++){
            if(arr1[i]&&arr1[i].count>1){
                arr3.push(arr1[i]);
            }
        }
        for(let i=0;i<arr2.length;i++){
            if(arr2[i]&&arr2[i].count>1){
                arr4.push(arr2[i]);
            }
        }
        // if(arr3.length&&haveCombieFlag1){
        //     for(let i=0;i<arr3.length;i++){
        //         if(columnIndex===arr3[i].columnIndex){
        //             if(rowIndex%arr3[i].count==(arr3[i].line-1)){
        //                 return{
        //                     rowspan:arr3[i].count,
        //                     colspan:1
        //                 };
        //             }else {
        //                 return {
        //                     rowspan:0,
        //                     colspan:0
        //                 };
        //             }
        //         }
        //     }
        // }
        if(arr4.length&&haveCombieFlag2){
            for(let i=0;i<arr4.length;i++){
                if(columnIndex==arr4[i].columnIndex){
                    if(rowIndex==arr4[i].line-2){
                        return {
                            rowspan:1,
                            colspan:1
                        }
                    }
                    if((rowIndex-1)%arr4[i].count==(0)){
                        return{
                            rowspan:arr4[i].count,
                            colspan:1
                        };
                    }else{
                        return {
                            rowspan:0,
                            colspan:1
                        }
                    }
                }
                else{
                    return {
                        rowspan:1,
                        colspan:1
                    }
                }
            }
        }
    },
    testCode1({row, column, rowIndex, columnIndex }){
        // 第一行不合并，第二行开始合并三行
                // if(columnIndex==1){
        //     if(rowIndex==0){
        //         return {
        //             rowspan:1,
        //             colspan:1
        //         }
        //     }
        //     if(((rowIndex-1)%3===0)){
        //         console.log(rowIndex);
        //         return{
        //             rowspan:3,
        //             colspan:1
        //         };
        //     }else{
        //         console.log(rowIndex);
        //         return {
        //             rowspan:0,
        //             colspan:1
        //         };
        //     }
        // }
        // else{
        //     return{
        //         rowspan:1,
        //         colspan:1
        //     }
        // }


    },
    testCode2({row, column, rowIndex, columnIndex }){
        // 第一列合并三行，第二列合并三行
        // const cyclePos = rowIndex % 6;
        //     if (cyclePos < 3) {
        //         if (columnIndex === 1) {
        //             if (cyclePos === 0) {
        //                 return { rowspan: 3, colspan: 1 };
        //             } else {
        //                 return { rowspan: 0, colspan: 1 };
        //             }
        //         }
        //     } else {
        //         if (columnIndex === 0) {
        //             if (cyclePos === 3) {
        //                 return { rowspan: 3, colspan: 1 };
        //             } else {
        //                 return { rowspan: 0, colspan: 1 };
        //             }
        //         }
        //     }
            // return { rowspan: 1, colspan: 1 };
    },
    testCode3({row, column, rowIndex, columnIndex}){
        if(rowIndex<=2){
            if (columnIndex === 1) {
                if (rowIndex === 0) {
                    return { rowspan: 3, colspan: 1 };
                } else {
                    return { rowspan: 0, colspan: 1 };
                }
            }
        }else {
            if (columnIndex === 0) {
                if (rowIndex === 3) {
                    return { rowspan: 3, colspan: 1 };
                } else {
                    return { rowspan: 0, colspan: 1 };
                }
            }
        }
            return { rowspan: 1, colspan: 1 };
    },
    testCode4({row, column, rowIndex, columnIndex}){
          // columnIndex：0=第一列，1=第二列，2=第三列
            // ========== 第二列（columnIndex=1）：1、2、3行合并3行 ==========
            if (columnIndex === 1) {
                // 第0行（第一行）开始合并3行
                if (rowIndex === 0) {
                return { rowspan: 3, colspan: 1 };
                }
                // 第1、2行被合并，直接隐藏
                if (rowIndex === 1 || rowIndex === 2) {
                return { rowspan: 0, colspan: 1 };
                }
                // 4、5、6、7、8、9行全部不合并，默认返回1*1，无需处理
            }

            // ========== 第一列（columnIndex=0）：6、7、8行合并3行 ==========
            if (columnIndex === 0) {
                // 第5行（第六行，索引从0开始）开始合并3行
                if (rowIndex === 5) {
                return { rowspan: 3, colspan: 1 };
                }
                // 第6、7行被合并，隐藏
                if (rowIndex === 6 || rowIndex === 7) {
                return { rowspan: 0, colspan: 1 };
                }
            }

            // 其余单元格不合并，默认1行1列
            return { rowspan: 1, colspan: 1 };
    },
    testCode5({row, column, rowIndex, columnIndex}){
            if(rowIndex>=0&&rowIndex<=2&&rowIndex!=8){
                if(columnIndex==1){
                    if(rowIndex==0){
                        return {
                            rowspan:3,
                            colspan:1
                        };
                    }else{
                        return {
                            rowspan:0,
                            colspan:1
                        };
                    }
                }
            }else if(rowIndex>=5&&rowIndex<=7&&rowIndex!=8&&(rowIndex<3||rowIndex>4)){
                if(columnIndex==0){
                    if(rowIndex==5){
                        return {
                            rowspan:3,
                            colspan:1,
                        }
                    }else{
                        return{
                            rowspan:0,
                            colspan:1
                        }
                    }
                }
            }else if((rowIndex>=3&&rowIndex<=4)||rowIndex==8){
                return {
                    rowspan:1,
                    colspan:1
                };
            }
                return {rowspan:1,colspan:1};
    },
    testCode6({row,column,rowIndex,columnIndex}){
        if(rowIndex>=0&&rowIndex<3
        &&(rowIndex<3||rowIndex>4||rowIndex<7||rowIndex>8)){
            if(columnIndex==1){
                if(rowIndex==0){
                    return {
                        rowspan:3,
                        colspan:1
                    }
                }else{
                    return {
                        rowspan:0,
                        colspan:1
                    }
                }
            }
        }else if(rowIndex>=5&&rowIndex<=6
        &&(rowIndex<3||rowIndex>4||rowIndex<7||rowIndex>8)){
            if(columnIndex==0){
                if(rowIndex==5){
                    return {
                        rowspan:2,
                        colspan:1
                    }
                }else{
                    return {
                        rowspan:0,
                        colspan:1
                    }
                }
            }
        }else if((rowIndex>=3&&rowIndex<=4)&&(rowIndex>=7&&rowIndex<=8)){
            return {
                rowspan:1,
                colspan:1
            }
        }
        return {rowspan:1,colspan:1}
    },
    testCode7({row,column,rowIndex,columnIndex}){
        if(rowIndex>=0&&rowIndex<=2&&rowIndex!=3&&(rowIndex<8||rowIndex>10)){
            if(columnIndex==1){
                if(rowIndex==0){
                    return{
                        rowspan:3,
                        colspan:1
                    }
                }else{
                    return {
                        rowspan:0,
                        colspan:1
                    };
                }
            }
        }else if(rowIndex>=4&&rowIndex<=5&&rowIndex!=3&&(rowIndex<8||rowIndex>10)){
            if(columnIndex==1){
                if(rowIndex==4){
                    return{
                        rowspan:2,
                        colspan:1
                    }
                }else{
                    return {
                        rowspan:0,
                        colspan:1
                    };
                }
            }
        }else if(rowIndex>=6&&rowIndex<=7&&rowIndex!=3&&(rowIndex<8||rowIndex>10)){
            if(columnIndex==0){
                if(rowIndex==6){
                    return{
                        rowspan:2,
                        colspan:1
                    }
                }else{
                    return {
                        rowspan:0,
                        colspan:1
                    };
                }
            }
        }else if(rowIndex==3&&rowIndex>=8&&rowIndex<=10){
            return {
                rowspan:1,
                colspan:1
            }
        }
        return {rowspan:1,colspan:1};
    },
    oldCode1(){
                // // 统计第一列疾病情况合并行的情况
        // const arr1=[...this.combieConditionList2];
        // // 统计第二例不予录取/不宜就读专业的情况
        // const arr2=[...this.combieZymcsList2];
        // // 筛选出第一列疾病情况需要合并多行的数据
        // const arr3=[];
        // // 筛选出第二列不予录取/不宜就读的合并多行的数据
        // const arr4=[];
        // // 筛选出不需要合并的第一列疾病情况的数据
        // const arr5=[];
        // // 筛选出不需要合并的第二列不予录取/不宜就读的数据
        // const arr6=[];
        // // 筛选出单行显示的数据（需满足第一列和第二列都不需要跨行）
        // const arr7SingleRow=[];
        // let haveCombieFlag1=false;
        // let haveCombieFlag2=false;
        // for(let i=0;i<arr1.length;i++){
        //     if(arr1[i]&&arr1[i].count>1){
        //         haveCombieFlag1=true;
        //         break;
        //     }
        // }
        // for(let i=0;i<arr2.length;i++){
        //     if(arr2[i]&&arr2[i].count>1){
        //         haveCombieFlag2=true;
        //         break;
        //     }
        // }
        // for(let i=0;i<arr1.length;i++){
        //     if(arr1[i]&&arr1[i].count>1){
        //         arr3.push(arr1[i]);
        //     }else{
        //         arr5.push(arr1[i]);
        //     }
        // }
        // for(let i=0;i<arr2.length;i++){
        //     if(arr2[i]&&arr2[i].count>1){
        //         arr4.push(arr2[i]);
        //     }else{
        //         arr6.push(arr2[i]);
        //     }
        // }
        // for(let i=0;i<arr5.length;i++){
        //     for(let j=0;j<arr6.length;j++){
        //         if(arr5[i].line==arr6[j].line){
        //             const obj={};
        //             obj.line=arr5[i].line;
        //             obj.leftContent=arr5[i].diseaseCondition;
        //             obj.rightContent=arr6[j].zymcs;
        //             arr7SingleRow.push(obj);
        //         }
        //     }
        // }
        // if(arr3.length&&arr4.length&&haveCombieFlag1&&haveCombieFlag2){
        //     console.log(arr3,arr4);
        //     if(arr3.length==1&&arr4.length==1&&arr7SingleRow.length==0){
        //         for(let i=0;i<arr3.length;i++){
        //             for(let j=0;j<arr4.length;j++){
        //                 const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                 const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                 console.log(maxRow,arr3);
        //                 console.log(maxRow2,arr4);
        //                 if(maxRow<maxRow2){
        //                     if(rowIndex<=maxRow){
        //                         if(columnIndex==arr3[i].columnIndex){
        //                             if(rowIndex==arr3[i].line-1){
        //                                 return {
        //                                     rowspan:arr3[i].count,
        //                                     colspan:1
        //                                 }
        //                             }else{
        //                                 return {
        //                                     rowspan:0,
        //                                     colspan:1
        //                                 }
        //                             }
        //                         } 
        //                     }else if(rowIndex>maxRow&&rowIndex<=maxRow2){
        //                         if(columnIndex==arr4[j].columnIndex){
        //                             if(rowIndex==arr4[j].line-1){
        //                                 return {
        //                                     rowspan:arr4[j].count,
        //                                     colspan:1
        //                                 }
        //                             }else{
        //                                 return {
        //                                     rowspan:0,
        //                                     colspan:1
        //                                 }
        //                             }
        //                         }
        //                     }
        //                 }else if(maxRow>maxRow2){
        //                     if(rowIndex<=maxRow2){
        //                         if(columnIndex==arr4[j].columnIndex){
        //                             if(rowIndex==arr4[j].line-1){
        //                                 return {
        //                                     rowspan:arr4[j].count,
        //                                     colspan:1
        //                                 }
        //                             }else{
        //                                 return {
        //                                     rowspan:0,
        //                                     colspan:1
        //                                 }
        //                             }
        //                         }
        //                     }else if(rowIndex>maxRow2&&rowIndex<=maxRow){
        //                         if(columnIndex==arr3[i].columnIndex){
        //                             if(rowIndex==arr3[i].line-1){
        //                                 return {
        //                                     rowspan:arr3[i].count,
        //                                     colspan:1
        //                                 }
        //                             }else{
        //                                 return {
        //                                     rowspan:0,
        //                                     colspan:1
        //                                 }
        //                             }
        //                         } 
        //                     }
        //                 }
        //                 return {rowspan:1,colspan:1};
        //             }
        //         }
        //     }else if(arr3.length==1&&arr4.length==1&&arr7SingleRow.length>0){
        //         // 统计需要单独显示不跨行连续的行数据
        //         let arr8=[];
        //         // 统计需要单独显示不跨行不连续的单独行数据
        //         let arr9=[];
        //         for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr7SingleRow.length;j++){
        //                 if(arr7SingleRow[i].line+1==arr7SingleRow[j].line){
        //                     const arr8HaveFlag1=arr8.find(item=>{
        //                         return arr7SingleRow[i].leftContent==item.leftContent;
        //                     });
        //                     const arr8HaveFlag2=arr8.find(item=>{
        //                         return arr7SingleRow[j].leftContent==item.leftContent;
        //                     });
        //                     if(!arr8HaveFlag1){
        //                         arr8.push(arr7SingleRow[i]);
        //                     }
        //                     if(!arr8HaveFlag2){
        //                         arr8.push(arr7SingleRow[j]);
        //                     }
        //                 }
        //             }
        //         }
        //         for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr8.length;j++){
        //                 if(arr7SingleRow[i].leftContent!=arr8[j].leftContent){
        //                     const twoLineFlag1=arr8.find(item=>{
        //                         return item.leftContent==arr7SingleRow[i].leftContent;
        //                     });
        //                     if(!twoLineFlag1){
        //                         const oneLIneFlag1=arr9.find(item=>{
        //                             return item.leftContent==arr7SingleRow[i].leftContent;
        //                         });
        //                         if(!oneLIneFlag1){
        //                             arr9.push(arr7SingleRow[i]);
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //         // 单行不跨行连续的行数据是否有2对以上
        //         let arr8HaveManySeries=false;
        //         // 有几个分割开的切割点（把跨行数据切割开）
        //         // 切割之后 左边尾节点 右边首节点
        //         let cuttingCount=0;
        //         // 3/4 7/8、和3/4、7
        //         for(let i=0;i<arr8.length;i++){
        //             if(arr8[i]&&arr8[i+1]&&arr8[i+2]
        //             &&arr8[i].line+1!=arr8[i+1].line&&arr8[i+1].line+1==arr8[i+2].line){
        //                 arr8HaveManySeries=true;
        //                 break;
        //             }
        //         }
        //         for(let i=0;i<arr8.length;i++){
        //             if(arr8[i]&&arr8[i+1]&&arr8[i+2]
        //             &&arr8[i].line+1!=arr8[i+1].line&&arr8[i+1].line+1==arr8[i+2].line){
        //                 cuttingCount++;
        //             }
        //         }
        //         console.log(cuttingCount);
        //         console.log(arr3,arr4);
        //         console.log(arr8,arr9);
        //         if(!arr8HaveManySeries){
        //             if(arr8.length>0&&arr9.length>0){
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let b=0;b<arr8.length;b++){
        //                                     for(let c=0;c<arr9.length;c++){
        //                                         const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                         const firstLine=(arr3[i].line-1);
        //                                         const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                         const firstLine2=(arr4[j].line-1);
        //                                         if(maxRow<maxRow2){
        //                                             if(rowIndex>=firstLine&&rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }else if(rowIndex>=firstLine2
        //                                             &&rowIndex!=arr9[c].line-1
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow2){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }
        //                                         }else if(maxRow>maxRow2){
        //                                             if(rowIndex>=firstLine2&&rowIndex<=maxRow2
        //                                             &&rowIndex!=arr9[c].line-1){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }else if(rowIndex>=firstLine
        //                                             &&rowIndex!=arr9[c].line-1
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }
        //                                         }else if(rowIndex==arr9[c].line-1
        //                                         ||(rowIndex>=arr8[0].line-1
        //                                         &&rowIndex<=arr8[arr8.length-1].line-1)){
        //                                             return{
        //                                                 rowspan:1,
        //                                                 colspan:1
        //                                             }
        //                                         }
        //                                         return {rowspan:1,colspan:1};
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }else if(arr8.length>0){
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let b=0;b<arr8.length;b++){
        //                                     {
        //                                         const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                         const firstLine=(arr3[i].line-1);
        //                                         const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                         const firstLine2=(arr4[j].line-1);
        //                                         if(maxRow<maxRow2){
        //                                             if(rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }else if(rowIndex>maxRow
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow2){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }
        //                                         }else if(maxRow>maxRow2){
        //                                             if(rowIndex>=firstLine2
        //                                             &&rowIndex<=maxRow2
        //                                             ){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }else if(rowIndex>=firstLine
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }
        //                                         }else if((rowIndex>=arr8[0].line-1
        //                                         &&rowIndex<=arr8[arr8.length-1].line-1)){
        //                                             return{
        //                                                 rowspan:1,
        //                                                 colspan:1
        //                                             }
        //                                         }
        //                                         return {rowspan:1,colspan:1};
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }else if(arr9.length>0){
                        
        //             }
        //         }else{
        //             if(cuttingCount==1){
        //                 let leftLastIndex1=-1;
        //                 let rightFirstIndex1=-1;
        //                 let leftListCount=0;
        //                 let rightListCount=0;
        //                 for(let i=0;i<arr8.length;i++){
        //                     if(arr8[i].line+1!=arr8[i+1].line){
        //                         leftLastIndex1=i;
        //                         rightFirstIndex1=i+1;
        //                         break;
        //                     }
        //                 }
        //                 if(leftLastIndex1>=0&&rightFirstIndex1>=0){
        //                     leftListCount=leftLastIndex1-0+1;
        //                     rightListCount=(arr8.length-1)-rightFirstIndex1+1;
        //                 }
        //                 // 每队单独连续的行处理对象
        //                 // 减掉1
        //                 const handleObj1={};
        //                 const objCount=2;
        //                 for(let i=0;i<objCount;i++){
        //                     const str1='handleTab'+(i+1);
        //                     handleObj1['maxIndex']=objCount-1;
        //                     handleObj1['name'+(i+1)]=str1;
        //                     handleObj1['firstIndex'+(i+1)]=i==0?leftLastIndex1-1:i==1?rightFirstIndex1:0;
        //                     handleObj1['lastIndex'+(i+1)]=i==0?leftLastIndex1-1:i==1?rightFirstIndex1:0;
        //                     handleObj1['count'+(i+1)]=i==0?leftListCount:i==1?rightListCount:0;
        //                 }
                        
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let b=0;b<arr8.length;b++){
        //                                     for(let c=0;c<handleObj1['maxIndex']+1;c++){
        //                                         {
        //                                             const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                             const firstLine=(arr3[i].line-1);
        //                                             const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                             const firstLine2=(arr4[j].line-1);
        //                                             if(maxRow<maxRow2){
        //                                                 if(rowIndex<=maxRow){
        //                                                     if(columnIndex==arr3[i].columnIndex){
        //                                                         if(rowIndex==arr3[i].line-1){
        //                                                             return {
        //                                                                 rowspan:arr3[i].count,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }else{
        //                                                             return {
        //                                                                 rowspan:0,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }
        //                                                     } 
        //                                                 }else if(rowIndex>maxRow
        //                                                 &&(rowIndex<arr8[handleObj1['firstIndex'+(c+1)]].line-1||
        //                                                 rowIndex>arr8[handleObj1['lastIndex'+(c+1)]].line-1)
        //                                                 &&rowIndex<=maxRow2){
        //                                                     if(columnIndex==arr4[j].columnIndex){
        //                                                         if(rowIndex==arr4[j].line-1){
        //                                                             return {
        //                                                                 rowspan:arr4[j].count,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }else{
        //                                                             return {
        //                                                                 rowspan:0,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }else if(maxRow>maxRow2){
        //                                                 if(rowIndex>=firstLine2
        //                                                 &&rowIndex<=maxRow2
        //                                                 ){
        //                                                     if(columnIndex==arr4[j].columnIndex){
        //                                                         if(rowIndex==arr4[j].line-1){
        //                                                             return {
        //                                                                 rowspan:arr4[j].count,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }else{
        //                                                             return {
        //                                                                 rowspan:0,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }
        //                                                     }
        //                                                 }else if(rowIndex>=firstLine
        //                                                 &&(rowIndex<arr8[handleObj1['firstIndex'+(c+1)]].line-1||
        //                                                 rowIndex>arr8[handleObj1['lastIndex'+(c+1)]].line-1)
        //                                                 &&rowIndex<=maxRow){
        //                                                     if(columnIndex==arr3[i].columnIndex){
        //                                                         if(rowIndex==arr3[i].line-1){
        //                                                             return {
        //                                                                 rowspan:arr3[i].count,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }else{
        //                                                             return {
        //                                                                 rowspan:0,
        //                                                                 colspan:1
        //                                                             }
        //                                                         }
        //                                                     } 
        //                                                 }
        //                                             }else if((rowIndex>=arr8[handleObj1['firstIndex'+(c+1)]].line-1
        //                                             &&rowIndex<=arr8[handleObj1['lastIndex'+(c+1)]].line-1)){
        //                                                 return{
        //                                                     rowspan:1,
        //                                                     colspan:1
        //                                                 }
        //                                             }
        //                                             return {rowspan:1,colspan:1};
        //                                         }
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }
        //         }
        //     }else if(arr3.length==1&&arr4.length==3&&arr7SingleRow.length>0){
        //         // 统计需要单独显示不跨行连续的行数据
        //         let arr8=[];
        //         // 统计需要单独显示不跨行不连续的单独行数据
        //         let arr9=[];
        //         for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr7SingleRow.length;j++){
        //                 if(arr7SingleRow[i].line+1==arr7SingleRow[j].line){
        //                     const arr8HaveFlag1=arr8.find(item=>{
        //                         return arr7SingleRow[i].leftContent==item.leftContent;
        //                     });
        //                     const arr8HaveFlag2=arr8.find(item=>{
        //                         return arr7SingleRow[j].leftContent==item.leftContent;
        //                     });
        //                     if(!arr8HaveFlag1){
        //                         arr8.push(arr7SingleRow[i]);
        //                     }
        //                     if(!arr8HaveFlag2){
        //                         arr8.push(arr7SingleRow[j]);
        //                     }
        //                 }
        //             }
        //         }
        //         for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr8.length;j++){
        //                 if(arr7SingleRow[i].leftContent!=arr8[j].leftContent){
        //                     const twoLineFlag1=arr8.find(item=>{
        //                         return item.leftContent==arr7SingleRow[i].leftContent;
        //                     });
        //                     if(!twoLineFlag1){
        //                         const oneLIneFlag1=arr9.find(item=>{
        //                             return item.leftContent==arr7SingleRow[i].leftContent;
        //                         });
        //                         if(!oneLIneFlag1){
        //                             arr9.push(arr7SingleRow[i]);
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //         // 单行不跨行连续的行数据是否有2对以上
        //         let arr8HaveManySeries=false;
        //         // 有几个分割开的切割点（把跨行数据切割开）
        //         // 切割之后 左边尾节点 右边首节点
        //         let cuttingCount=0;
        //         // 3/4 7/8、和3/4、7
        //         for(let i=0;i<arr8.length;i++){
        //             if(arr8[i]&&arr8[i+1]&&arr8[i+2]
        //             &&arr8[i].line+1!=arr8[i+1].line&&arr8[i+1].line+1==arr8[i+2].line){
        //                 arr8HaveManySeries=true;
        //                 break;
        //             }
        //         }
        //         for(let i=0;i<arr8.length;i++){
        //             if(arr8[i]&&arr8[i+1]&&arr8[i+2]
        //             &&arr8[i].line+1!=arr8[i+1].line&&arr8[i+1].line+1==arr8[i+2].line){
        //                 cuttingCount++;
        //             }
        //         }
        //         console.log(arr8HaveManySeries);
        //         console.log(arr3,arr4);
        //         console.log(arr8,arr9);
        //         if(!arr8HaveManySeries){
        //             const handleObj2={};
        //             for(let i=0;i<arr4.length;i++){
        //                 if(arr4[i]){
        //                     const firstLine=(arr4[i].line-1);
        //                     const lastLine=(arr4[i].line-1)+(arr4[i].count-1);
        //                     handleObj2['combie'+(i+1)]='line'+(i+1);
        //                     handleObj2['firstIndex'+(i+1)]=firstLine;
        //                     handleObj2['lastIndex'+(i+1)]=lastLine;
        //                     handleObj2['maxIndex']=arr4.length-1;
        //                     handleObj2['columnIndex'+(i+1)]=arr4[i].columnIndex;
        //                     handleObj2['combieCount'+(i+1)]=arr4[i].count;
        //                 }
        //             }
        //             // 1 1 1 1 1  小于最大索引

        //             if(arr8.length>0&&arr9.length>0){
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let b=0;b<arr8.length;b++){
        //                                     for(let c=0;c<arr9.length;c++){
        //                                         for(let d=0;d<handleObj2['maxIndex']+1;d++){
        //                                             {
        //                                                 const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                                 const firstLine=(arr3[i].line-1);
        //                                                 const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                                 const firstLine2=(arr4[j].line-1);
        //                                                 if(rowIndex>=firstLine
        //                                                 &&rowIndex<=maxRow
        //                                                     &&rowIndex!=arr9[c].line-1
        //                                                     &&((rowIndex<arr8[0].line-1
        //                                                     ||rowIndex>arr8[arr8.length-1].line-1))
        //                                                 ){
        //                                                         if(columnIndex==arr3[i].columnIndex){
        //                                                             if(rowIndex==arr3[i].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr3[i].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         } 
        //                                                 }else if(rowIndex>=handleObj2['firstIndex'+(d+1)]
        //                                                     &&rowIndex!=arr9[c].line-1
        //                                                     &&(rowIndex<arr8[0].line-1||
        //                                                     rowIndex>arr8[arr8.length-1].line-1)
        //                                                     &&rowIndex<=handleObj2['lastIndex'+(d+1)]){
        //                                                         if(columnIndex==handleObj2['columnIndex'+(d+1)]){
        //                                                             if(rowIndex==handleObj2['firstIndex'+(d+1)]){
        //                                                                 return {
        //                                                                     rowspan:handleObj2['combieCount'+(d+1)],
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         }
        //                                                 }else if(rowIndex>=handleObj2['firstIndex'+(handleObj2['maxIndex']+1)]
        //                                                     &&rowIndex!=arr9[c].line-1
        //                                                     &&(rowIndex<arr8[0].line-1||
        //                                                     rowIndex>arr8[arr8.length-1].line-1)
        //                                                     &&rowIndex<=handleObj2['lastIndex'+(handleObj2['maxIndex']+1)]){
        //                                                         if(columnIndex==handleObj2['columnIndex'+(handleObj2['maxIndex']+1)]){
        //                                                             if(rowIndex==handleObj2['firstIndex'+(handleObj2['maxIndex']+1)]){
        //                                                                 return {
        //                                                                     rowspan:handleObj2['combieCount'+(handleObj2['maxIndex']+1)],
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         }
        //                                                 }else if(rowIndex==arr9[c].line-1
        //                                                 ||(rowIndex>=arr8[0].line-1
        //                                                 &&rowIndex<=arr8[arr8.length-1].line-1)){
        //                                                     return{
        //                                                         rowspan:1,
        //                                                         colspan:1
        //                                                     }
        //                                                 }
        //                                                 return {rowspan:1,colspan:1};
        //                                             }
        //                                         }
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }else if(arr8.length>0&&!arr9.length){
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let b=0;b<arr8.length;b++){
        //                                     {
        //                                         const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                         const firstLine=(arr3[i].line-1);
        //                                         const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                         const firstLine2=(arr4[j].line-1);
        //                                         if(maxRow<maxRow2){
        //                                             if(rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }else if(rowIndex>maxRow
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow2){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }
        //                                         }else if(maxRow>maxRow2){
        //                                             if(rowIndex>=firstLine2
        //                                             &&rowIndex<=maxRow2
        //                                             ){
        //                                                 if(columnIndex==arr4[j].columnIndex){
        //                                                     if(rowIndex==arr4[j].line-1){
        //                                                         return {
        //                                                             rowspan:arr4[j].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 }
        //                                             }else if(rowIndex>=firstLine
        //                                             &&(rowIndex<arr8[0].line-1||
        //                                             rowIndex>arr8[arr8.length-1].line-1)
        //                                             &&rowIndex<=maxRow){
        //                                                 if(columnIndex==arr3[i].columnIndex){
        //                                                     if(rowIndex==arr3[i].line-1){
        //                                                         return {
        //                                                             rowspan:arr3[i].count,
        //                                                             colspan:1
        //                                                         }
        //                                                     }else{
        //                                                         return {
        //                                                             rowspan:0,
        //                                                             colspan:1
        //                                                         }
        //                                                     }
        //                                                 } 
        //                                             }
        //                                         }else if((rowIndex>=arr8[0].line-1
        //                                         &&rowIndex<=arr8[arr8.length-1].line-1)){
        //                                             return{
        //                                                 rowspan:1,
        //                                                 colspan:1
        //                                             }
        //                                         }
        //                                         return {rowspan:1,colspan:1};
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }else if(arr9.length>0&&!arr8.length){
                        
        //             }else if(!arr8.length&&!(arr9.length)){
        //                 let secondCombieCount=0;
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                 for(let d=0;d<handleObj2['maxIndex']+1;d++){
        //                                     {
        //                                         console.log(d);
        //                                                 const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                                 const firstLine=(arr3[i].line-1);
        //                                                 const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                                 const firstLine2=(arr4[j].line-1);
        //                                                 if(rowIndex>=firstLine
        //                                                 &&rowIndex<=maxRow
        //                                                     &&rowIndex!=arr7SingleRow[a].line-1
        //                                                 ){
        //                                                         if(columnIndex==arr3[i].columnIndex){
        //                                                             if(rowIndex==arr3[i].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr3[i].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         } 
        //                                                 }
        //                                                 // else if(rowIndex>=handleObj2['firstIndex'+(d+1)]
        //                                                 //     &&rowIndex!=arr7SingleRow[a].line-1
        //                                                 //     &&rowIndex<=handleObj2['lastIndex'+(d+1)]){
        //                                                 //         if(columnIndex==handleObj2['columnIndex'+(d+1)]){
        //                                                 //             if(rowIndex==handleObj2['firstIndex'+(d+1)]){
        //                                                 //                 return {
        //                                                 //                     rowspan:handleObj2['combieCount'+(d+1)],
        //                                                 //                     colspan:1
        //                                                 //                 }
        //                                                 //             }else{
        //                                                 //                 return {
        //                                                 //                     rowspan:0,
        //                                                 //                     colspan:1
        //                                                 //                 }
        //                                                 //             }
        //                                                 //         }
        //                                                 // }else if(rowIndex>=handleObj2['firstIndex'+(handleObj2['maxIndex']+1)]
        //                                                 //     &&rowIndex!=arr7SingleRow[a].line-1
        //                                                 //     &&rowIndex<=handleObj2['lastIndex'+(handleObj2['maxIndex']+1)]){
        //                                                 //         if(columnIndex==handleObj2['columnIndex'+(handleObj2['maxIndex']+1)]){
        //                                                 //             if(rowIndex==handleObj2['firstIndex'+(handleObj2['maxIndex']+1)]){
        //                                                 //                 return {
        //                                                 //                     rowspan:handleObj2['combieCount'+(handleObj2['maxIndex']+1)],
        //                                                 //                     colspan:1
        //                                                 //                 }
        //                                                 //             }else{
        //                                                 //                 return {
        //                                                 //                     rowspan:0,
        //                                                 //                     colspan:1
        //                                                 //                 }
        //                                                 //             }
        //                                                 //         }
        //                                                 // }
                                                        
        //                                                 else if(rowIndex==arr7SingleRow[a].line-1){
        //                                                     return{
        //                                                         rowspan:1,
        //                                                         colspan:1
        //                                                     }
        //                                                 }
        //                                                 return {rowspan:1,colspan:1};
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                 }
        //             }
        //         }else{
        //             if(cuttingCount>0){
        //                 let leftLastIndex1=-1;
        //                 let rightFirstIndex1=-1;
        //                 let leftListCount=0;
        //                 let rightListCount=0;
        //                 for(let i=0;i<arr8.length;i++){
        //                     if(arr8[i].line+1!=arr8[i+1].line){
        //                         leftLastIndex1=i;
        //                         rightFirstIndex1=i+1;
        //                         break;
        //                     }
        //                 }
        //                 if(leftLastIndex1>=0&&rightFirstIndex1>=0){
        //                     leftListCount=leftLastIndex1-0+1;
        //                     rightListCount=(arr8.length-1)-rightFirstIndex1+1;
        //                 }
        //                 // 每队单独连续的行处理对象
        //                 // 减掉1
        //                 const handleObj1={};
        //                 const objCount=2;
        //                 for(let i=0;i<objCount;i++){
        //                     const str1='handleTab'+(i+1);
        //                     handleObj1['maxIndex']=objCount-1;
        //                     handleObj1['name'+(i+1)]=str1;
        //                     handleObj1['firstIndex'+(i+1)]=i==0?leftLastIndex1-1:i==1?rightFirstIndex1:0;
        //                     handleObj1['lastIndex'+(i+1)]=i==0?leftLastIndex1-1:i==1?rightFirstIndex1:0;
        //                     handleObj1['count'+(i+1)]=i==0?leftListCount:i==1?rightListCount:0;
        //                 }
        //                 for(let i=0;i<arr3.length;i++){
        //                         for(let j=0;j<arr4.length;j++){
        //                             for(let a=0;a<arr7SingleRow.length;a++){
        //                                     for(let d=0;d<handleObj1['maxIndex']+1;d++){
        //                                         for(let c=0;c<handleObj1['maxIndex']+1;c++){
        //                                             {
        //                                                 const maxRow=(arr3[i].line-1)+arr3[i].count-1;
        //                                                 const firstLine=(arr3[i].line-1);
        //                                                 const maxRow2=(arr4[j].line-1)+arr4[j].count-1;
        //                                                 const firstLine2=(arr4[j].line-1);
        //                                                 if(maxRow<maxRow2){
        //                                                     if(rowIndex<=maxRow){
        //                                                         if(columnIndex==arr3[i].columnIndex){
        //                                                             if(rowIndex==arr3[i].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr3[i].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         } 
        //                                                     }else if(rowIndex>maxRow
        //                                                     &&(rowIndex<arr8[handleObj1['firstIndex'+(c+1)]].line-1||
        //                                                     rowIndex>arr8[handleObj1['lastIndex'+(c+1)]].line-1)
        //                                                     &&rowIndex<=maxRow2){
        //                                                         if(columnIndex==arr4[j].columnIndex){
        //                                                             if(rowIndex==arr4[j].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr4[j].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         }
        //                                                     }
        //                                                 }else if(maxRow>maxRow2){
        //                                                     if(rowIndex>=firstLine2
        //                                                     &&rowIndex<=maxRow2
        //                                                     ){
        //                                                         if(columnIndex==arr4[j].columnIndex){
        //                                                             if(rowIndex==arr4[j].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr4[j].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         }
        //                                                     }else if(rowIndex>=firstLine
        //                                                     &&(rowIndex<arr8[handleObj1['firstIndex'+(c+1)]].line-1||
        //                                                     rowIndex>arr8[handleObj1['lastIndex'+(c+1)]].line-1)
        //                                                     &&rowIndex<=maxRow){
        //                                                         if(columnIndex==arr3[i].columnIndex){
        //                                                             if(rowIndex==arr3[i].line-1){
        //                                                                 return {
        //                                                                     rowspan:arr3[i].count,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }else{
        //                                                                 return {
        //                                                                     rowspan:0,
        //                                                                     colspan:1
        //                                                                 }
        //                                                             }
        //                                                         } 
        //                                                     }
        //                                                 }else if((rowIndex>=arr8[handleObj1['firstIndex'+(c+1)]].line-1
        //                                                 &&rowIndex<=arr8[handleObj1['lastIndex'+(c+1)]].line-1)){
        //                                                     return{
        //                                                         rowspan:1,
        //                                                         colspan:1
        //                                                     }
        //                                                 }
        //                                                 return {rowspan:1,colspan:1};
        //                                             }
        //                                         }
        //                                     }
        //                             }
        //                         }
        //                 }
        //             }
        //         }
        //     }
        // }else if(arr3.length&&haveCombieFlag1){
        //     for(let i=0;i<arr3.length;i++){
        //         if(columnIndex===arr3[i].columnIndex){
        //             if(rowIndex%arr3[i].count===(arr3[i].line-1)){
        //                 return{
        //                     rowspan:arr3[i].count,
        //                     colspan:1
        //                 };
        //             }else {
        //                 return {
        //                     rowspan:0,
        //                     colspan:1
        //                 };
        //             }
        //         }
        //         else{
        //             return {
        //                 rowspan:1,
        //                 colspan:1
        //             }
        //         }
        //     }
        // }else if(arr4.length&&haveCombieFlag2){
        //     // for(let i=0;i<arr4.length;i++){
        //     //     if(columnIndex==arr4[i].columnIndex){
        //     //         if(rowIndex%arr4[i].count===(arr4[i].line-1)){
        //     //             return{
        //     //                 rowspan:arr4[i].count,
        //     //                 colspan:1
        //     //             };
        //     //         }else{
        //     //             return {
        //     //                 rowspan:0,
        //     //                 colspan:1
        //     //             }
        //     //         }
        //     //     }
        //     //     else{
        //     //         return {
        //     //             rowspan:1,
        //     //             colspan:1
        //     //         }
        //     //     }
        //     // }
               
        //     // 统计需要单独显示不跨行连续的行数据
        //     let arr8=[];
        //     // 统计需要单独显示不跨行不连续的单独行数据
        //     let arr9=[];
        //     for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr7SingleRow.length;j++){
        //                 if(arr7SingleRow[i].line+1==arr7SingleRow[j].line){
        //                     arr8.push(arr7SingleRow[i]);
        //                     arr8.push(arr7SingleRow[j]);
        //                 }
        //             }
        //     }
        //     for(let i=0;i<arr7SingleRow.length;i++){
        //             for(let j=0;j<arr8.length;j++){
        //                 if(arr7SingleRow[i].leftContent!=arr8[j].leftContent){
        //                     const twoLineFlag1=arr8.find(item=>{
        //                         return item.leftContent==arr7SingleRow[i].leftContent;
        //                     });
        //                     if(!twoLineFlag1){
        //                         const oneLIneFlag1=arr9.find(item=>{
        //                             return item.leftContent==arr7SingleRow[i].leftContent;
        //                         });
        //                         if(!oneLIneFlag1){
        //                             arr9.push(arr7SingleRow[i]);
        //                         }
        //                     }
        //                 }
        //             }
        //     }
        //     console.log(arr3,arr4);
        //     console.log(arr8,arr9);
        //     for(let i=0;i<arr3.length;i++){
        //                 for(let j=0;j<arr4.length;j++){
        //                     for(let a=0;a<arr7SingleRow.length;a++){
        //                         for(let b=0;b<arr8.length;b++){
        //                             for(let c=0;c<arr9.length;c++){
        //                                 const maxRow=(arr4[j].line-1)+arr4[j].count-1;
        //                                 const firstLine=arr4[j].line-1+arr4[j].count-1;
        //                                 if(rowIndex>=firstLine-1&&rowIndex<=maxRow
        //                                 ){
        //                                         if(columnIndex==arr4[j].columnIndex){
        //                                             if(rowIndex==arr4[j].line-1){
        //                                                 return {
        //                                                     rowspan:arr4[j].count,
        //                                                     colspan:1
        //                                                 }
        //                                             }else{
        //                                                 return {
        //                                                     rowspan:0,
        //                                                     colspan:1
        //                                                 }
        //                                             }
        //                                         } 
        //                                 }
        //                                 return {rowspan:1,colspan:1};
        //                             }
        //                         }
        //                     }
        //                 }
        //     }
        // }
    },
    // 跨行，跨列
    objectSpanMethod2({row, column, rowIndex, columnIndex }){
        // 疾病情况列跨行情况
        const arr1=this.getSpanArr(this.majorData2,'diseaseCondition');
        // 不予录取/不予就读的专业情况
        const arr2=this.getSpanArr(this.majorData2,'zymcs');
        if(columnIndex==0){
            const diseaseConditionCount=arr1[rowIndex];
            return (diseaseConditionCount?{rowspan:diseaseConditionCount,colspan:1}:
            {rowspan:0,colspan:0})
        }
        if(columnIndex==1){
            const zymcs=arr2[rowIndex];
            return (zymcs?{rowspan:zymcs,colspan:1}:
            {rowspan:0,colspan:0})
        }
        return {rowspan:1,colspan:1}
    },
    // 处理合并行代码
    hanldeCombieLine({row,column,rowIndex,columnIndex},obj,index){
        const arr1=[a,b,c,d,e];
        if(a.a>0){

        }else if(b.a>=0){

        }
    },
    // ===== 【重点】生成合并所需 span 数组工具函数 =====
    /**
     * @param {Array} data 表格数据
     * @param {String} prop 需要合并的字段名
     * @returns {Array} spanArr 每行需要合并的rowspan数组
     */
    getSpanArr(data,prop){
        const spanList=[];
        let pos=0;
        data.forEach((item,index)=>{
            if(index==0){
                spanList.push(1);
                pos=0;
            }else{
                // 和上一行对比字段值是否相同
                if(data[index][prop]==data[index-1][prop]){
                    spanList[pos]+=1;
                    spanList.push(0);
                }else{
                    spanList.push(1);
                    pos=index;
                }
            }
        });
        return spanList;
    },
    // 动态拼接执行判断
    checkFilter(data){
        // { field: 'age', op: '>=', value: 18 },
        return this.filterRules.some(rule => {
            const target = data[rule.field]
            const val = rule.value
            console.log(target,val);
            switch (rule.op) {
                case '>': return target > val
                case '>=': return target >= val
                case '<': return target < val
                case '<=': return target <= val
                case '==': return target == val
                case '===': return target === val
                case '!=': return target != val
                case '!==': return target !== val
                case 'includes': return target.includes(val)
                default: return true
            }
        })
    }
},
mounted(){
    this.majorData1=this.bodyMajorData;
}
}
</script>
<style scoped>

</style>